import Link from 'next/link';
import { ChevronRight } from '@/lib/icons';

interface BreadcrumbItem {
  name: string;
  url: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export function Breadcrumbs({ items }: BreadcrumbsProps) {
  // Always include Home as the first item
  const breadcrumbItems = [
    { name: 'Home', url: '/' },
    ...items
  ];

  return (
    <>
      {/* Visual Breadcrumbs */}
      <nav aria-label="Breadcrumb" className="mb-0">
        <ol className="flex items-center space-x-2 text-sm text-gray-600">
          {breadcrumbItems.map((item, index) => (
            <li key={item.url} className="flex items-center">
              {index > 0 && (
                <ChevronRight className="w-4 h-4 mx-2 text-gray-400" />
              )}
              
              {index === breadcrumbItems.length - 1 ? (
                // Current page (not a link)
                <span className="text-gray-900 font-medium">
                  {item.name}
                </span>
              ) : (
                // Parent pages (links)
                <Link 
                  href={item.url}
                  className="hover:text-primary transition-colors"
                >
                  {item.name}
                </Link>
              )}
            </li>
          ))}
        </ol>
      </nav>
    </>
  );
}